import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: "Pensé que era normal vivir con el pecho apretado. La primera noche que usé la técnica de 'Vaciado' del capítulo 2, dormí 7 horas de corrido después de meses. Me cambió el humor en el laburo.",
    name: 'Guillermo R.',
    role: 'Programador (CABA)',
    result: 'Sueño profundo en 2 días',
    delay: 0
  }, {
    text: 'Como madre de tres, nunca tengo tiempo para mí. Esta guía es corta, va al grano y los audios de regalo son lo único que logra hacerme desconectar antes de dormir. Por fin me levanto con energía.',
    name: 'Marcela T.',
    role: 'Administrativa (Córdoba)',
    result: 'Menos irritabilidad y más energía',
    delay: 100
  }, {
    text: 'Dudaba porque ya había probado de todo. Pero el enfoque de este ebook es distinto, es muy práctico para los que vivimos a mil en este país. Vale cada peso.',
    name: 'Lucas M.',
    role: 'Empleado (Rosario)',
    result: 'Control total de ataques de pánico',
    delay: 200
  }];
  return <section className="py-24 bg-[#0a0e1a] relative" data-id="element-243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <FadeIn data-id="element-245">
          <div className="text-center mb-16" data-id="element-246">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-247">
              Gente Real.{' '}
              <span className="text-emerald-400" data-id="element-248">Resultados Reales.</span>
            </h2>
            <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-249">
              No somos gurús de internet. Somos argentinos que encontramos una
              salida al estrés crónico.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-250">
          {testimonials.map((t, index) => <FadeIn key={index} delay={t.delay} className="h-full" data-id="element-251">
              <div className="bg-slate-800/30 p-8 rounded-2xl border border-slate-700/50 h-full flex flex-col relative group hover:bg-slate-800/50 transition-colors duration-300" data-id="element-252">
                <Quote className="absolute top-6 right-6 w-12 h-12 text-slate-700/50 group-hover:text-amber-500/20 transition-colors" data-id="element-253" />

                <div className="flex text-amber-400 mb-6" data-id="element-254">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-current" data-id="element-255" />)}
                </div>

                <p className="text-slate-300 text-lg italic mb-8 flex-grow relative z-10" data-id="element-256">
                  "{t.text}"
                </p>

                <div className="mt-auto pt-6 border-t border-slate-700/50" data-id="element-257">
                  <p className="font-bold text-white text-lg" data-id="element-258">{t.name}</p>
                  <p className="text-slate-400 text-sm mb-3" data-id="element-259">{t.role}</p>
                  <div className="inline-flex items-center gap-2 bg-emerald-500/10 text-emerald-400 text-xs font-bold px-3 py-1.5 rounded-full border border-emerald-500/20" data-id="element-260">
                    <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-261"></span>
                    Resultado: {t.result}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}